import { darkGrayFontColor } from '../../../../styles/colors';
import { StyleSheet } from 'aphrodite';

export const styleSheet = StyleSheet.create({
	contact: {
		display: 'inline-flex',
		margin: '4px 0 0 4px',
		maxWidth: '80%',
	},
	container: {
		color: darkGrayFontColor,
		fontSize: 12,
		letterSpacing: 0,
		overflow: 'hidden',
	},
	content: {
		display: 'flex',
		flexWrap: 'wrap',
	},
	overflow: {
		padding: ' 6px 0',
	},
	tag: {
		display: 'inline-flex',
		margin: '4px 0 0 4px',
		maxWidth: '80%',
	},
});
